import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../services/login.service';
import {ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-pwd',
  templateUrl: './forgot-pwd.component.html',
  styleUrls: ['./forgot-pwd.component.scss']
})
export class ForgotPwdComponent implements OnInit {
  public password1: string;
  public password2: string;

  private token: string;
  private tokenId: string;

  constructor(private loginService: LoginService,
              private router: Router,
              private translate: TranslateService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe(map => {
      this.token = decodeURIComponent(map.get('token'));
      this.tokenId = decodeURIComponent(map.get('token_id'));
    });
  }

  resetPwd() {
    this.loginService
      .resetPassword(this.password1, this.token, this.tokenId)
      .subscribe(() => this.router.navigate(['']));
  }

}
